export default __webpack_public_path__ + "static/media/blueSnapchat.045c1111.svg";